import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const schedulesApiRoutes = {
    list: apiBusSchedBaseURL + "schedules/",
    listCarris: apiBusSchedBaseURL + "draw/custom/carris/",
};

export class ScheduleAPI {
    static list(planningEdition) {
        const url = new URL(schedulesApiRoutes.list);

        return API.authenticatedRequest({
            url: `${url}?planningEditionsEncoded=${planningEdition}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listCarris(planningEdition) {
        const url = new URL(planningEdition, schedulesApiRoutes.listCarris);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static activeByLine(planningEdition, line, referenceDate) {
        const url = new URL(`${line}/${referenceDate}`, schedulesApiRoutes.list);

        return API.authenticatedRequest({
            url: `${url}?planningEditionsEncoded=${planningEdition}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
